export { default as DoctorForms } from "./DoctorForms";
